function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#479377",
  opacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#479377",
  d: "M18 27.333h-1.333v-7.996c0-.738.606-1.337 1.322-1.337h24.022c.175 0 .348.034.51.101.161.068.308.166.43.29.124.125.221.273.287.435.065.163.098.336.095.511v7.996H42v13.335c0 .174-.033.347-.1.508-.066.162-.163.308-.286.432-.123.124-.27.222-.43.29-.161.067-.334.101-.508.102H19.324c-.174 0-.347-.035-.508-.103-.16-.067-.307-.165-.43-.289-.123-.123-.22-.27-.287-.431-.066-.162-.1-.335-.099-.509V27.333zm21.333 0H20.667v12h18.666v-12zm-20-6.666v4h21.334v-4H19.333zM26 30h8v2.667h-8V30z"
});

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.07e9ae11.svg";
export { ForwardRef as ReactComponent };